import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import SearchBar from 'components/UI/V3/SearchBar/SearchBar';
import { FunctionComponent, useState } from 'react';

interface SearchProps {
    onSearch: (searchText: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        box: {
            position: 'relative'
        },
        searchContainer: {
            position: 'relative'
        }
    })
);

const Search: FunctionComponent<SearchProps> = props => {
    const classes = useStyles();
    const [searchText, setSearchText] = useState('');

    const handleSearchChange = (text: string) => {
        setSearchText(text);
        props.onSearch(text);
    };

    return (
        <Box className={classes.root}>
            <Box className={classes.box}>
                <SearchBar
                    searchText={searchText}
                    onChangeSearchText={handleSearchChange}
                    placeholder="Search by agreement name"
                    className={classes.searchContainer}
                />
            </Box>
        </Box>
    );
};

export default Search;
